module.exports = __webpack_public_path__ + "img/banner.ada99b2c.png";